<template>
<v-container>
  <v-row no-gutters justify="center" class="white wrapperBGCpage">
    <v-col class="boxDescription" cols="12" :md="9">
      <div class="leftBox"></div>
      <div class="contentBox">
        <div class="contentBox__title">{{bbcPage.subTitle.text}}</div>
        <div v-for="(item, idx) in bbcPage.subTitle.note" :key="idx" class="contentBox__note">
          <icon name="icon-arrow-round" width="45" height="19" class="mr-3"/>
          {{item}}
        </div>
      </div>
    </v-col>
    <v-col cols="12" class="text-center">
      <h2 class="primary--text text-uppercase py-5" v-translate>Management Pack BGC</h2>
      <v-row no-gutters class="rowBGC text-center" justify="space-between">
        <v-col cols="12" class="colBGC col-md-4 mb-sm-14" v-for="(data, idx) in bbcPage.package" :key="idx">
          <div class="boxedCol gray6">
            <div class="font-weight-bold text-uppercase pt-8 pb-5">{{data.name}}</div>
            <div class="flagBox">
              <v-img max-height="150"
                max-width="250"
                contain
                :src="iconUrl('tag-banner.png')">
                <template slot="default">
                  <div class="flagBox__content ml-8 mt-2">
                    <div class="py-1">
                      <span class="text-h4 pr-1 font-weight-bold white--text">{{data.priceMonth}}</span>
                      <translate class="subText white--text">$ / month</translate>
                    </div>
                    <p
                    class="subText white--text">{{data.priceYear}}<translate>$ / year</translate></p>
                  </div>
                </template>
              </v-img>
            </div>
            <div class="text-start mx-6">
              <p v-for="(text, index) in data.content" :key="index" class="d-flex align-center">
                <icon name="icon-sticker" width="20" height="20" class="mr-3"/>
                {{text}}
              </p>
            </div>
          </div>
          <v-btn rounded class="btnContact" @click="$emit('openDialog', data)">
            <translate>Contact us</translate>
            <icon name="icon-sent" width="25" height="25" class="ml-3"/>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row no-gutters></v-row>
</v-container>
</template>

<script>
export default {
  name: "BGC",
  data() {
    return {
      bbcPage: {
        subTitle: {
          text: this.$gettext('Only 1 way to succeed, be consistently visible for the Golf world community'),
          note: [
            this.$gettext('Post interesting content regularly'),
            this.$gettext('Reply to comments, reviews and Vlogs on your BGC page'),
            this.$gettext('Express your interest by following and commenting posts on others pages and golfers’ profiles')
          ],
        },
        package: [
          {
            name: this.$gettext('Pack Birdie'),
            priceMonth: this.$gettext('49'),
            priceYear: this.$gettext('539'),
            content: [
              this.$gettext('1 post par Week'),
              this.$gettext('Reply every new review'),
              this.$gettext('Comments on every new VLOGs on page'),
              this.$gettext('30 comments/month on post feeds in country'),
              this.$gettext('Pack ads 10 000 display. /Month on your country location'),
              this.$gettext('Follow new register – Max 30/month in the country'),
            ]
          },
          {
            name: this.$gettext('Pack Eagle'),
            priceMonth: this.$gettext('99'),
            priceYear: this.$gettext('1 089'),
            content: [
              this.$gettext('1 post par Week'),
              this.$gettext('Reply every new review'),
              this.$gettext('Comments on every new VLOGs on page'),
              this.$gettext('60 comments/month on post feeds with the page log AREA'),
              this.$gettext('Pack ads 50 000 display. /Month on AREA'),
              this.$gettext('Follow new register – max 150/month in the AREA'),
            ]
          },
          {
            name: this.$gettext('Pack Albatross'),
            priceMonth: this.$gettext('149'),
            priceYear: this.$gettext('1 639'),
            content: [
              this.$gettext('1 post par Week'),
              this.$gettext('Reply every new review'),
              this.$gettext('Comments on every new VLOGs on page'),
              this.$gettext('120 comments/month on post feeds 3 Area to Worldwide'),
              this.$gettext('Pack ads 150 000 display. /Month from 3 Area to Worldwide'),
              this.$gettext('Pack Follow new register - max 300/month worldwide'),
            ]
          }
        ]
      }
    }
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>
